import { defineComponent as _defineComponent } from 'vue'

import type { MetaInfo } from 'vue-meta/types/vue-meta';

const __default__ = {
	name: 'LegacyNewsArticle',
	metaInfo() {
		return (this as unknown as { metaInfo: MetaInfo }).metaInfo;
	},
};

import type { NewsProvision } from '@/features/editorial/components/article/legacy/useLegacyArticle';
import type { TitleDetail } from '@/interfaces/title-details-graphql';

import { getBackdropClips } from '@/helpers/title-helper';
import { getArticleBackdrop } from '@/features/editorial/helper';
import { useEditorialTracking } from '@/features/editorial/tracking';

import AdUnit from '@/components/AdUnit.vue';
import GridBuyBox from '@/features/buybox/components/grid/GridBuyBox.vue';
import TitleCredits from '@/components/details/TitleCredits.vue';
import TitleInfo from '@/components/details/TitleInfo.vue';
import TitleDetailStreamingChart from '@/components/details/streaming-chart/TitleDetailStreamingChart.vue';
import BackdropTrailer from '@/components/details/backdrops/BackdropTrailer.vue';
import GuideList from '@/features/editorial/components/GuideList.vue';

import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    article: null,
    mainObject: null
  },
  emits: ["content-clicked"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: 'content-clicked', event: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	article: NewsProvision['article'];
	mainObject: NewsProvision['mainObject'];
};

const { trackEditorial } = useEditorialTracking();





const mainObj = computed(() => props.mainObject as TitleDetail);

const titleClips = computed(() => getBackdropClips(props.mainObject as any));

const trailerThumbnail = computed(() => {
	const title = props.mainObject;

	const pathExtension = title.content.fullPath
		? `/${title.content.fullPath.substring(title.content.fullPath.lastIndexOf('/') + 1)}`
		: '';

	return title.content.backdrops.map(backdrop => backdrop.backdropUrl + pathExtension)[0] ?? '';
});

/* Page Meta */
const metaInfo = computed<MetaInfo>(() => {
	const backdropUrl = getArticleBackdrop(props.mainObject, 'backdrop');
	if (backdropUrl == null) return { meta: undefined };

	return {
		meta: [
			{ vmid: 'og:image', property: 'og:image', content: backdropUrl },
			{ vmid: 'og:image:width', property: 'og:image:width', content: '1920' },
			{ vmid: 'og:image:height', property: 'og:image:height', content: '900' },
		],
	};
});

expose({ metaInfo });

const isInWatchList = computed(
	() => props.mainObject.__typename !== 'Season' && !!props.mainObject.watchlistEntryV2?.createdAt
);

/* Trailer Handling */
const activeClipId = ref<string | null>(null);
function setActiveClip(value: string) {
	activeClipId.value = value;

	trackEditorial('clickPlayOnTrailer', {
		spec: { action: props.mainObject.objectType },
		contexts: [new SnowplowTitleContextGraphql(props.mainObject.objectId, props.mainObject.objectType)],
	});
}

/* TRACKING */
function trackClick(e: Event) {
	const target = e.target as HTMLElement;
	const anchorElement = target.parentNode?.parentNode;
	if (anchorElement?.nodeName !== 'A') return;

	const property = (anchorElement as HTMLAnchorElement).href;

	trackEditorial('clickArticleLink', {
		spec: { label: property?.includes('justwatch.com') ? 'internal' : 'external', property },
	});
}

return { __sfc: true,trackEditorial, props, emit, mainObj, titleClips, trailerThumbnail, metaInfo, isInWatchList, activeClipId, setActiveClip, trackClick, AdUnit, GridBuyBox, TitleCredits, TitleInfo, TitleDetailStreamingChart, BackdropTrailer, GuideList }
}

})